// import Form from 'olive-react-myoneui/lib/Form';
// import FloatingLabel from 'olive-react-myoneui/lib/FloatingLabel';
// import ToggleButtonGroup from 'olive-react-myoneui/lib/ToggleButtonGroup';
// import ToggleButton from 'olive-react-myoneui/lib/ToggleButton';
import React from 'react';
import CircleImage from 'olive-react-myoneui/lib/CircleImage';
// import CircleImageContent from 'olive-react-myoneui/lib/CircleImageContent';
import Button from 'olive-react-myoneui/lib/Button';

function ReminderBlock({ className, reminderLogo, reminderTitle, reminderButton, joinLink, reminderTime, reminderType }) {

  let itemTypes = ['live', 'assignment', 'link'];

  const joinClickHandler = (e) => {
    if(reminderType == 'live'){
      window.open(joinLink, '_blank');
    } else {
      window.location.href = joinLink;
    }
  }
  return (
    <div
      className={`${
        className || ""
      } reminder-block information-block information-block-sm-pd bg-ghost-white`}
    >
      <div className="information-wrap">
        <div className="information-holder gap-2  custom-info-holder">
        <div className="information-wrap-holder">
          {reminderLogo && (
            <CircleImage className="circle-wrap square-wrap">
              <img src={reminderLogo} className="img-fluid" />
            </CircleImage>
          )}
          {/* <div className="information-info-details"> */}
            <div className="information-detail">
              <h3 className="mb-1">{reminderTitle}</h3>
              {reminderTime && <span>{reminderTime}</span>}
            </div>
        </div>
        {itemTypes.includes(reminderType) &&
            <Button variant="outline" className="dark btn-round btn-sm" onClick={joinClickHandler}>
              {reminderButton}
            </Button>
        }
            
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default ReminderBlock;
